var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-wrapper"},[(_vm.info.productmallWaresAbstracts)?_c('EditorView',{attrs:{"data":_vm.info.productmallWaresAbstracts}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }